export async function domToSvg(node) {
  if (!node) {
    return
  }
  const { elementToSVG } = await window.requireOnDemand('dom-to-svg')
  const svgDocument = elementToSVG(node)
  const svg = new window.XMLSerializer().serializeToString(svgDocument)
  return svg
}
